'use client';

import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from './utils/cn';

const progressVariants = cva('relative w-full overflow-hidden rounded-full bg-secondary', {
  defaultVariants: {
    size: 'default',
  },
  variants: {
    size: {
      default: 'h-2',
      lg: 'h-4',
      md: 'h-3',
      sm: 'h-1',
    },
  },
});

interface ProgressProps
  extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>,
    VariantProps<typeof progressVariants> {}

const Progress = React.forwardRef<React.ElementRef<typeof ProgressPrimitive.Root>, ProgressProps>(
  ({ className, value, size, ...props }, ref) => (
    <ProgressPrimitive.Root className={cn(progressVariants({ className, size }))} ref={ref} {...props}>
      <ProgressPrimitive.Indicator
        className='h-full w-full flex-1 bg-primary transition-all'
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  ),
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
